import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  const value = props.data ? props.data[props.colDef.field] : null;
  const reitName = props.data ? props.data.reitName : null;
  const id = props.data ? props.data.id : null;

  return (
    <span>
      <MotifCheckbox
        type="checkbox"
        name="arqc-cell-checkbox"
        id={`ag-arqc-cell-checkbox-${id}`}
        checked={value}
        tabIndex="-1"
        aria-label="Press Space to toggle ARQC row selection"
        onClick={() => props.onCellCheckboxChange(id, props.node)}
        data-testid={`chkPublishArqc${reitName}`}
      ></MotifCheckbox>
    </span>
  );
};
